export const NAME = 'benefitsEffectiveDates'

// API routes
export const POST_BENEFITEFFECTIVEDATES_ROUTE =
  'employeeBenefitsEffectivedatesPost'
